import * as React from "react";
import { cn } from "../lib/utils";
import { Button } from "./button";
import { Archive } from "lucide-react";

const SidebarMenu = React.forwardRef(
  ({ className, type, exportAllNotes, ...props }, ref) => {
    return (
      // Return with the innerHTML of the sidebar
      <aside
        className={cn(
          "flex flex-col space-y-1 p-4 text-sm border-[1px] border-transparent border-r-[#E4E4E7] dark:border-r-[#27272A] w-[288px] h-full",
          className
        )}
        {...props}
      >
        {props.children}
        <br />
        <span>
          Please make sure you have backups of your data. Browser storage is
          inheritly unreliable and unstable, so there is always a risk of data
          loss. Use at your own risk.
        </span>
        <div className="flex items-center justify-between mt-4">
          <a href="/privacy" className="flex items-center space-x-2">
            <span className="text-gray-700">Privacy</span>
          </a>
          <Button
            onClick={exportAllNotes}
            variant="ghost"
            size="sm"
            className="flex items-center gap-1 text-gray-700 hover:text-gray-700 dark:hover:text-gray-200"
          >
            <Archive className="h-4 w-4" />
            <span>Export All</span>
          </Button>
        </div>
      </aside>
    );
  }
);
SidebarMenu.displayName = "SidebarMenu";

export { SidebarMenu };
